import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pages/$id")({
  component: lazyRouteComponent(() => import("./-pages/admin.pages.$id")),
  head: () => ({ meta: [{ title: "تحرير صفحة · Admin · Lecmo" }] }),
});
